'use client'

import { useState, useCallback } from 'react'
import { ShortlistCar } from '@lib/redux/slices/shortlistSlice'

export interface WishlistToastState {
  show: boolean
  carMake: string
  carName: string
  isAdding: boolean
  lastAction?: {
    carName: string
    isAdded: boolean
  }
}

export const useWishlistToast = (duration = 3000) => {
  const [toast, setToast] = useState<WishlistToastState>({
    show: false,
    carMake: '',
    carName: '',
    isAdding: true
  })

  const showToast = useCallback((car: ShortlistCar, isAdding: boolean) => {
    setToast({
      show: true,
      carMake: car.make,
      carName: car.name,
      isAdding,
      lastAction: {
        carName: car.name,
        isAdded: isAdding
      }
    })

    const timer = setTimeout(() => {
      setToast(prev => ({ ...prev, show: false }))
    }, duration)

    return () => clearTimeout(timer)
  }, [duration])

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, show: false }))
  }, [])

  return {
    toast,
    showToast,
    hideToast
  }
} 